// @ts-nocheck
import React from 'react';
import KwPanel from '../../../common/KwPanel';
import FormInput from '../../../common/FormInput';
import { useTranslation } from 'react-i18next';
import PackageTypeKeyProviders from './PackageTypeKeyProviders';

const PackageTypeForm = ({ packageType, register, errors, setPackageType }) => {
  const { t } = useTranslation();

  const handleKeyProviderChange = (keyProvider, value) => {
    if (!keyProvider || !packageType) {
      return;
    }

    let keyProviderReferences = { ...packageType.keyProviderReferences };

    keyProviderReferences[keyProvider.id] = value;

    setPackageType({ ...packageType, keyProviderReferences });
  };

  return packageType ? (
    <>
      <KwPanel className="mb-4 pb-3 pt-2">
        <FormInput
          register={register}
          required={true}
          error={errors.name}
          errorMessage={t('Required')}
          name="name"
          label={t('Name')}
          defaultValue={packageType.name || ''}
          autoFocus={true}
          testId={'package-type-name'}
        />
      </KwPanel>
      <PackageTypeKeyProviders
        onChange={handleKeyProviderChange}
        packageTypeKeyProviders={packageType?.keyProviderReferences ?? {}}
      />
    </>
  ) : (
    ''
  );
};



export default PackageTypeForm;
